const interceptorRequest = (config, user) => {
  config.headers = {
    ...config.headers,
    Authorization:
      config.headers?.Authorization || `Bearer ${user.accessToken}`,
    "Content-Type": config.headers?.["Content-Type"] || "application/json",
    Accept: "application/json"
  };

  return config;
};

const interceptorResponseSuccess = (response) => {
  return response;
};

const interceptorResponseError = (error, user, callback) => {
  if (user && error.response?.status === 401) {
    callback();
  }
  throw error;
};

export {
  interceptorRequest,
  interceptorResponseSuccess,
  interceptorResponseError
};
